import React from 'react';
import PropTypes from 'prop-types';
import { StyledFlexbox } from 'components/atoms/Flexbox/styled';
import Button from 'components/atoms/Button';
import { DomElementsIdentifiers } from 'common/constants/common';
import { Wrapper } from './styled';

const FormFooter = ({
  onSave,
  onCancel,
  bottom = 10,
  inProcess,
  disabled,
  isForm,
  cancelText = 'Indietro',
  submitText = 'Salva',
  style,
  mobPadding,
  hideSubmit = false,
  hideCancel = false,
  submitDisabled,
  submitPadding,
  submitMaxW,
}) => {
  return (
    <Wrapper style={style} mobPadding={mobPadding}>
      {!hideCancel && (
        <Button
          onClick={onCancel}
          mr={10}
          color='cancel'
          flex={1}
          disabled={inProcess || disabled}
          maxW={hideSubmit ? '155' : '155'}
        >
          {cancelText}
        </Button>
      )}
      {!hideSubmit && (
        <Button
          p={submitPadding}
          id={DomElementsIdentifiers.footerSubmit}
          type={isForm ? 'submit' : 'button'}
          onClick={onSave}
          color='action'
          flex={1}
          maxW={submitMaxW}
          loading={inProcess}
          disabled={inProcess || disabled || submitDisabled}
        >
          {submitText}
        </Button>
      )}
    </Wrapper>
  );
};

FormFooter.propTypes = {
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  bottom: PropTypes.number,
  cancelText: PropTypes.string,
  submitText: PropTypes.string,
  inProcess: PropTypes.bool,
  isForm: PropTypes.bool,
  disabled: PropTypes.bool,
  mobPadding: PropTypes.string,
  style: PropTypes.shape({}),
};

export default FormFooter;
